import { render, staticRenderFns } from "./step1-selectLocation.vue?vue&type=template&id=b6d49a60&scoped=true"
import script from "./step1-selectLocation.vue?vue&type=script&lang=js"
export * from "./step1-selectLocation.vue?vue&type=script&lang=js"
import style0 from "./step1-selectLocation.vue?vue&type=style&index=0&id=b6d49a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d49a60",
  null
  
)

export default component.exports